import { apiGet, apiPost } from '../js/api';
import Server from '../js/config/_server';

type typePostData = {
    deviceNumber: string;
    type: string;
    url: string;
    customerName: string;
    message: string;
    template: string;
    state: string;
    [key: string]: string;
};

export const getAssetOverride = (deviceNumber: string) => {
    const apiCallParams = new URLSearchParams({
        page: '1',
        deviceNumber,
    })
    const url = Server.baseUrl + Server.services.assetsOverride.get + '?' + apiCallParams.toString();
    return apiGet(url);
};

export const postAssetOverride = (args: typePostData) => {
    const url = Server.baseUrl + Server.services.assetsOverride.post;
    const options = {
        body: args,
    };
    return apiPost(url, options);
};

export const assetsOverride = {
    getAssetOverride,
    postAssetOverride,
};



